// extracted by mini-css-extract-plugin
export var dropdownIcon = "_qu-6";
export var imgContainer = "_qu-3";
export var menuIcon = "_qu-5";
export var pillWrapper = "_qu-2";
export var pillsContainer = "_qu-1";
export var subscriptionCard = "_qu-0";
export var subscriptionLogo = "_qu-4";